import { type ReactNode } from 'react'
import { FormContainer } from '@/components/FormContainer'
import { PersonalInfoEditor } from '@/features/tax-profile/individual-profiles/components/PersonalInfoEditor'
import type { DependentProfileEditorViewModel } from '@/features/tax-profile/individual-profiles/DependentProfileEditorViewModel'
import { TextFieldContainer } from '@/components/inputs/TextFieldContainer'
import { FormFieldSet, FormFieldSetLegend } from '@/components/Form'
import { observer } from 'mobx-react-lite'

export interface DependentProfileEditorProps {
  children?: ReactNode
  formId?: string
  isDisabled?: boolean
  vm: DependentProfileEditorViewModel
}

/**
 * Form for editing a dependent profile.
 */
export const DependentProfileEditor = observer(function DependentProfileEditor({
  formId,
  isDisabled,
  vm,
}: DependentProfileEditorProps) {
  const testId = 'dependent-profile-editor'
  return (
    <FormContainer
      id={formId}
      onSubmit={vm.save}
      disabled={isDisabled || vm.save.pending}
      testId={testId}
    >
      <FormFieldSet>
        <FormFieldSetLegend>
          Dependent's personal information
        </FormFieldSetLegend>
        <PersonalInfoEditor vm={vm.personalInfoVm} testId={testId} />
        <TextFieldContainer
          model={vm}
          field="relationship"
          label="Relationship"
          placeholder="e.g. Son, Daughter, Stepchild"
          testId={`${testId}-relationship-input`}
        />
      </FormFieldSet>
    </FormContainer>
  )
})
